const { transferStatus } = require('@transfeeradev/api-enums');

class TransferStatusDescriptionService {
  static display(status, statusDescription) {
    if (status === transferStatus.FAILED_INTERNAL) {
      return null;
    }
    return statusDescription;
  }
}

module.exports = TransferStatusDescriptionService;
